





















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import EmptyContent from "@/components/EmptyContent";
import LevelItem from "@/views/PageSubscriptionLevels/components/LevelItem.vue";

@Component({ name: "LevelsView", components: { LevelItem, EmptyContent, BaseButton } })
export default class LevelsView extends Vue {
  @Prop({ required: true })
  public readonly priceList!: SubscriptionLevel[];

  @Prop({ required: true })
  public readonly packageList!: PaymentPackage[];

  get description() {
    if (this.priceList.length < 2) return $t("This is the monthly subscription price for your page");
    return $t("Here are different monthly subscription levels for your page");
  }
}
